(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SubscribeController', SubscribeController);

    SubscribeController.$inject = ['Subscribe'];

    function SubscribeController(Subscribe) {

        var vm = this;

        vm.subscribes = [];

        loadAll();

        function loadAll() {
            Subscribe.query(function(result) {
                vm.subscribes = result;
                vm.searchQuery = null;
            });
        }
    }
})();
